import { render, staticRenderFns } from "./ProjectwiseRoiReport.vue?vue&type=template&id=597ce105&"
import script from "./ProjectwiseRoiReport.vue?vue&type=script&lang=js&"
export * from "./ProjectwiseRoiReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports